import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button } from "@mantine/core";
import { assignFlag } from "../../../../services/flag";
import { useSelectFlagData } from "../../../../redux/features/flagDetails/flagDetailsSlice";
import { useRole } from "../../../../redux/features/user";

export default function AssignFlag() {
  const { id } = useParams();
  const role = useRole();
  const flagData = useSelectFlagData();
  const queryClient = useQueryClient();

  const { assigneeId } = flagData?.flagDetails || {};

  const assignRolePermission =
    role === "AML_CORDINATOR" || role === "GRANT_ADMIN";

  const assignMutation = useMutation({
    mutationKey: ["assign-flag", id],
    mutationFn: () =>
      assignFlag({
        flagId: id,
        assign: true,
      }),
    onSuccess: async ({ data }) => {
      await queryClient.refetchQueries(["flag-details", id]);
      toast.success("Flag assigned successfully.");
    },
    onError: (err) => {
      toast.error(
        err.response?.data?.message ||
          "An error occurred while assigning the flag.",
      );
    },
  });

  if (!!assigneeId && assignRolePermission) {
    return null; // if assigned or no permission to assign, hide the button
  }

  return (
    <Button
      loading={assignMutation.isPending}
      onClick={() => assignMutation.mutate(id)}
      variant="outline"
    >
      Assign
    </Button>
  );
}
